import type { Dayjs } from 'dayjs';
import { IllegalOperationException } from '../exceptions/illegal-operation-exception.js';
import { GiftCardValidityPeriod, GiftCardValidity, GiftCardValidityType } from '../models/serializable/gift-card/gift-card-validity.js';
import { GiftCardVariation } from '../models/serializable/gift-card/gift-card-variation.js';
import { Price } from '../models/serializable/price.js';
import { isSameData } from '../models/dto/data-model-utils.js';

export function resolveGiftCardExpirationDate(validity: GiftCardValidity, creationDate: Dayjs): Dayjs {
  if(validity.type === GiftCardValidityType.Custom && validity.expirationDate != null) {
    return validity.expirationDate.clone();
  }

  if(validity.type === GiftCardValidityType.Preset) {
    switch(validity.period) {
      case GiftCardValidityPeriod.HalfYear: return creationDate.add(180, 'day');
      case GiftCardValidityPeriod.Year: return creationDate.add(1, 'year');
    }
  }

  throw new IllegalOperationException('Cannot resolve expiration date for an incomplete gift-card validity.');
}

export function isGiftCardPriceAllowed(variation: Pick<GiftCardVariation, 'price' | 'isMinPrice'>, price: Price): boolean {
  if(!Number.isSafeInteger(price.value) || !price.isPositive() || !variation.price.isPositive() ||
    variation.price.currency !== price.currency) return false;
  return variation.isMinPrice ? price.value >= variation.price.value : isSameData(variation.price, price);
}
